import { withNamespaces } from "react-i18next"
import { RiBracesLine, RiBuilding4Line, RiCheckLine, RiCloseLine, RiInformationLine, RiMapPin2Line, RiQuestionLine, RiSettings5Fill, RiUser3Line } from "react-icons/ri"
import { Card, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap"
import Accordion from 'react-bootstrap/Accordion'
import { LocationStatuses } from "../../constants"

const BussinessNumber = ({ bNumber, description }) => {
    const valueToDisplay = `${bNumber ?? ''} ${description ? '(' + description + ')' : ''}`;

    return valueToDisplay.trim() ? valueToDisplay : 'Not provided'
}

const CompanyOverview = ({
    t,
    detailsQuery,
    setActiveAccordion,
    activeAccordion
}) => {
    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const {
        quickcheck,
        location_status
    } = organizationData || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('company-overview')}
            className={activeAccordion === 'company-overview' ? 'active' : ''}
            eventKey={'company-overview'}
        >
            <Accordion.Header>
                <RiBuilding4Line size="24" className="me-2" />
                <span>
                    {t('Company Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Row className="mb-3">
                    <Col sm="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="me-2 text-primary">
                                        <RiBuilding4Line size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Identity & Legal Info')}
                                    </div>
                                </div>

                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Trade Name')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.trade_name ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('DUNS')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.duns ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('D&B Key')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.dnb_key ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Legal Form Description')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.legal_form_description ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Business Number')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    <BussinessNumber 
                                                        bNumber={quickcheck.business_number}
                                                        description={quickcheck.business_number_description}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Business Number Type')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.business_number_type ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Incorporation Year')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.incorporation_year ?? 'N/A'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Start Year')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.start_year ?? 'N/A'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col sm="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="me-2 text-primary">
                                        <RiUser3Line size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Management')}
                                    </div>
                                </div>

                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('CEO Name')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.ceo_name ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('CEO Title')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.ceo_title ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col sm="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiMapPin2Line size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Location & Contact')}
                                    </div>
                                </div>

                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Address')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {(quickcheck.address?.filter(Boolean).join(', ')) || t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('City')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.city ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Sub-Region')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.subregion ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Region')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.region ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Country')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.country ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Postal Code')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.postcode ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Phone')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {`${quickcheck.country_calling_code ?? ''} ${quickcheck.phone_number ?? ''}`.trim() || t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Location Status')}
                                                    <span
                                                        id="tooltip-location_status"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-location_status"
                                                    >
                                                        {t('Indicates whether the subject business is a branch, headquarters, or single location.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {location_status ? `${location_status} ${LocationStatuses[location_status]?.title ? '(' + LocationStatuses[location_status].title + ')' : ''}` : t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col sm="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="me-2 text-primary">
                                        <RiBracesLine size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Industry & Activity')}
                                    </div>
                                </div>

                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('SIC Activity Code')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.sic_activity_code ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('SIC Activity Description')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.sic_activity_description ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('SIC Version')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.sic_version ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Local Activity Code')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.local_activity_code ?? t('Not provided')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="me-2 text-primary">
                                        <RiSettings5Fill size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Operational Info')}
                                    </div>
                                </div>

                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Total Employees')}
                                                    <span
                                                        id="tooltip-employees_total_count"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-employees_total_count"
                                                    >
                                                        {t('Number of employees working at the location or business.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.employees_total?.employees ?? '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Employees Estimated')}
                                                    <span
                                                        id="tooltip-employees_total_estimated"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-employees_total_estimated"
                                                    >
                                                        {t('Qualifies calculation of total employees.  If No, the number of employees is from an official source such as the Chamber of Commerce.  If Yes, the number of employees is estimated.')}
                                                    </UncontrolledTooltip> 
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.employees_total?.estimated === true ? (
                                                        <>
                                                            <RiCheckLine size={20} className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : quickcheck.employees_total?.estimated === false ? (
                                                        <>
                                                            <RiCloseLine size={20} className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiQuestionLine size={20} className="text-secondary" />
                                                            {t('Unknown')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Subsidiaries Included')}
                                                    <span
                                                        id="tooltip-employees_subsidiaries_included"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-employees_subsidiaries_included"
                                                    >
                                                        {t('Qualifies calculation of total employees. If Yes, subsidiaries are included in the total employee count. If No, they are not included.')}
                                                    </UncontrolledTooltip> 
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.employees_total?.subsidiaries_included === true ? (
                                                        <>
                                                            <RiCheckLine size={20} className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : quickcheck.employees_total?.subsidiaries_included === false ? (
                                                        <>
                                                            <RiCloseLine size={20} className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiQuestionLine size={20} className="text-secondary" />
                                                            {t('Unknown')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Out Of Business')}
                                                    <span
                                                        id="tooltip-employees_out_of_business"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-employees_out_of_business"
                                                    >
                                                        {t('Indicates that the company has discontinued operations.')}
                                                    </UncontrolledTooltip> 
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {quickcheck.out_of_business === true ? (
                                                        <>
                                                            <RiCheckLine size={20} className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : quickcheck.out_of_business === false ? (
                                                        <>
                                                            <RiCloseLine size={20} className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiQuestionLine size={20} className="text-secondary" />
                                                            {t('Unknown')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    CompanyOverview
)